module.exports = __webpack_public_path__ + "img/secKill_bg2.1bb43491.png";